export const testAreaId = 106082
